import React, { Fragment } from 'react'
import classnames from 'classnames'
import moment from 'moment'
import { StyledIntervalForm } from './styled'
import Calendar from './Calendar'
import { getValidDateNumber } from './helpers'
import { useTranslation } from 'react-i18next'
import { getMonthes } from 'helpers/utils'

const yearList = [moment().year() - 2, moment().year() - 1, moment().year()]
const currentDate = moment()

const DateIntervalForm = (props) => {
	const {
		year,
		setYear,
		monthInterval: { monthFrom, monthTo },
		dayInterval: { dayFrom, dayTo },
		setMonthInterval,
		setDayInterval,
		setIntervalFormVisible,
		handleDateChange,
		hideCalendar,
		onConfirm
	} = props

	const [, i18] = useTranslation()
	const monthList = getMonthes(i18.language)

	const formatedWeekFrom = dayFrom ? `${moment(dayFrom).format('dddd')}, ` : ' ',
		formatedWeekTo = dayFrom ? `${moment(dayTo).format('dddd')}, ` : ' '
	const formatedMonthFrom = !dayFrom ? `${moment(getValidDateNumber(monthFrom), 'MM').format('MMMM')}, ` : ' ',
		formatedMonthTo = !dayFrom ? `${moment(getValidDateNumber(monthTo), 'MM').format('MMMM')}, ` : ' '
	const formatedDayFrom = dayFrom
		? `${moment(dayFrom).format('DD MMMM')}, `
		: ''
	const formatedDayTo = dayFrom
		? `${moment(dayTo).format('DD MMMM')}, `
		: ''

	const [t] = useTranslation()

	const periodFrom = `${formatedMonthFrom}${formatedWeekFrom}${formatedDayFrom}${year}`,
		periodTo = `${formatedMonthTo}${formatedWeekTo}${formatedDayTo}${year}`

	const handleMonthPrev = () => {
		setMonthInterval(prevState => {
			const lastMonth = prevState.monthTo === 1
			setDayInterval(state => ({ ...state, dayFrom: null }))
			return {
				...prevState,
				monthTo: lastMonth ? 12 : prevState.monthTo - 1
			}
		})
	}

	const handleMonthNext = () => {
		if (currentDate.year() === year && currentDate.month() < monthTo) {
			return
		}
		setMonthInterval(prevState => {
			const lastMonth = prevState.monthTo === 12
			setDayInterval(state => ({ ...state, dayFrom: null }))
			return {
				...prevState,
				monthTo: lastMonth ? 1 : prevState.monthTo + 1
			}
		})
	}

	return (
		<StyledIntervalForm
			className='interval_form'
		>
			<div className='form_badge__container'>
				<div className='form_badge__container__label'>{t('common.dates.year')}:</div>
				<div className='form_badge__container__year_list'>
					{yearList.map(item => {
						return (
							<div
								key={item}
								onClick={() => {
									if (item === currentDate.year()) {
										setMonthInterval({
											monthFrom: null,
											monthTo: currentDate.month() + 1
										})
									} else {
										setMonthInterval({
											monthFrom: null,
											monthTo: currentDate.month() + 1
										})
									}
									setYear(item)
								}}
								className={classnames('form_badge', { active: year === item })}>
								{item}
							</div>
						)
					})}
				</div>
			</div>
			<div className='form_badge__container'>
				<div className='form_badge__container__label'>{t('common.dates.month')}:</div>
				<div className='form_badge__container__month_list'>
					{monthList.map((item, index) => {
						const now = moment(new Date())
						const isDisabled = (now.year() === year && index + 1 >= now.month() + 1)
						|| (now.year() - 1 === year && index + 1 === now.month())
						const activeFrom = monthFrom === index + 1
						// activeTo = monthTo === index + 1
						return (
							<div
								key={item}
								onClick={() => {
									setMonthInterval({ monthFrom: index + 1, monthTo })
									setDayInterval({ dayFrom: null, dayTo })
								}}
								className={classnames('form_badge',
									{
										'active': activeFrom, // eslint-disable-line
										'disabled': isDisabled // eslint-disable-line
									})}>
								{item}
							</div>
						)
					})}
				</div>
			</div>
			{!hideCalendar && (
				<Fragment>
					<div className='form_calendar__list'>
						<Calendar
							month={monthFrom}
							year={year}
							currentDate={dayFrom}
							hideControls
							handleDateChange={handleDateChange}
							changeKey='dayFrom'
						/>
						<Calendar
							month={monthTo}
							year={year}
							currentDate={dayTo}
							handleDateChange={handleDateChange}
							changeKey='dayTo'
							handleMonthPrev={handleMonthPrev}
							handleMonthNext={handleMonthNext}
						/>
					</div>
					<div className='form_badge__container'>
						<div className='form_badge__container__label'>{t('dashboard_section.period')}:</div>
						<div className='form_badge__container__period'>
							{monthTo < monthFrom ? periodTo : periodFrom}
							- {monthTo < monthFrom ? periodFrom : periodTo}
						</div>
					</div>
				</Fragment>
			)}
			<div className='form__actions'>
				<div
					onClick={() => setIntervalFormVisible(visible => !visible)}
					className='form__actions__btn form__actions__cancel'
				>
					{t('common.buttons.abort')}
				</div>
				<div
					onClick={() => {
						onConfirm({ year, monthFrom, dayFrom }, { year, monthTo, dayTo })
						setIntervalFormVisible(false)
					}}
					className={classnames('form__actions__btn form__actions__confirm', {
						disabled: monthFrom === null
					})}
				>
					OK
				</div>
			</div>
		</StyledIntervalForm>
	)
}

export default DateIntervalForm
